import Vue from 'vue'

export default {
    post(url, request, config) {
        if (config)
            return Vue.http.post(url, request, config)
                .then((response) => Promise.resolve(response.body))
                .catch((error) => Promise.reject(error))
        else
            return Vue.http.post(url, request)
                .then((response) => Promise.resolve(response.body))
                .catch((error) => Promise.reject(error))
    },
    get(url, config) {
        if (config)
            return Vue.http.get(url, config)
                .then((response) => Promise.resolve(response.body))
                .catch((error) => Promise.reject(error))
        else
            return Vue.http.get(url)
                .then((response) => Promise.resolve(response.body))
                .catch((error) => Promise.reject(error))
    }
}